import { component } from '@smoovy/component';

@component('[data-i18n]')
export class I18N {
  private translations: { [key: string]: string } = {};

  constructor(
    protected element: HTMLElement
  ) {
    this.translations = JSON.parse(this.element.dataset.i18n || '{}');

    this.init();
    this.element.classList.add('is-translated');
  }

  public init() {
    const lang = navigator.language || (navigator as any).userLanguage;
    const code = lang.split(/-|_/)[0]

    if (this.translations[code]) {
      this.element.innerHTML = this.translations[code];
    }
  }
}